import type { JobSeverity } from '@/features/jobs/types/job'

const jobSeverityLabels: Record<JobSeverity, string> = {
  expedited: 'Expedited',
  urgent: 'Urgent',
  bau: 'BAU',
}

export const formatJobSeverity = (severity: JobSeverity) =>
  jobSeverityLabels[severity]
